/**
 * Big inked lettering for the Fall countdown digits: the "countdown" preset of the juice
 * lettering baker (render/juice/juice-text.js: Fredoka 700, hard ink lip under the word,
 * round-joined ink stroke, a banded lit fill) with a thinner ink so a 2 or 3 keeps its counters
 * open and a larger bake cap, because the digit is shown at about 0.6 × the flask height
 * (≈ 95 px on desktop, × 2 on a retina canvas).
 *
 * One baker, one cache: the digits share juice-text's cache, so a digit canvas that is evicted
 * (resize, DPR change) or replaced (Fredoka arriving after a provisional bake) has its GPU
 * texture released like every other lettering canvas.
 */
import { getInkTextSprite } from "../../juice/juice-text.js";

/**
 * The baked word, drawn at `size` logical px (w / h are its logical draw size at that size).
 * @param {string} text
 * @param {string} color lit fill colour (#rrggbb), white on top, this colour below
 * @param {number} size logical font px
 * @param {{ dpr?: number }} [opts]
 * @returns {{ canvas: HTMLCanvasElement, w: number, h: number } | null}
 */
export function getFallLettering(text, color, size, opts) {
  var o = opts || {};
  return getInkTextSprite(text, color, size, { dpr: o.dpr, preset: "countdown" });
}
